import { v4 as uuidv4 } from "uuid";

const SESSION_KEY = "guest_session_id";
const BOOK_NOW_SESSION_KEY = "guest_booknow_session_id";

const createSessionManager = (storageKey: string) => ({
    get: (): string => {
        let sessionId = localStorage.getItem(storageKey);
        if (!sessionId) {
            sessionId = uuidv4();
            localStorage.setItem(storageKey, sessionId);
        }
        return sessionId;
    },

    set: (sessionId: string): void => {
        localStorage.setItem(storageKey, sessionId);
    },

    clear: (): void => {
        localStorage.removeItem(storageKey);
    },

    has: (): boolean => {
        return !!localStorage.getItem(storageKey);
    },
});

const cartSession = createSessionManager(SESSION_KEY);
const bookNowSession = createSessionManager(BOOK_NOW_SESSION_KEY);

export const sessionHelper = {
    getSessionId: cartSession.get,
    setSessionId: cartSession.set,
    clearSession: cartSession.clear,
    hasSession: cartSession.has,

    getBookNowSessionId: bookNowSession.get,
    setBookNowSessionId: bookNowSession.set,
    clearBookNowSession: bookNowSession.clear,
    hasBookNowSession: bookNowSession.has,
};
